export enum Role {
  Admin = 'admin',
  Sido = 'sido',
  PaOrMsp = 'paOrMsp'
}
